module.exports = __webpack_public_path__ + "static/media/k1bg.e484ac8a.png";